import script from "./IndexPart2.vue?vue&type=script&setup=true&lang=js"
export * from "./IndexPart2.vue?vue&type=script&setup=true&lang=js"

import "./IndexPart2.vue?vue&type=style&index=0&id=6b11a86e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b11a86e"]])

export default __exports__